export const careDefaultParameters = {
  "dailyPlan": [
    {
      "title": "Medications",
      "name": "medications",
      "enabled": false,
      "actions": [
        {
          "title": "Add SD Setup / Change",
          "name": "addSDSetup",
          "enabled": false
        },
        {
          "title": "Add Medication",
          "name": "addMedication",
          "enabled": false
        },
        {
          "title": "Add PRN medication",
          "name": "addPRNMedication",
          "enabled": false
        },
        {
          "title": "Add Cream",
          "name": "addCream",
          "enabled": false
        },
        {
          "title": "Add Insulin",
          "name": "addInsulin",
          "enabled": false
        }
      ]
    },
    {
      "title": "Recurring Actions",
      "name": "recurringActions",
      "enabled": true,
      "actions": [
        {
          "title": "Personal Care",
          "name": "personalCare",
          "enabled": true,
          "actions": [
            {
              "title": "Catheter care",
              "name": "catheterCare",
              "enabled": false
            },
            {
              "title": "Menstruation",
              "name": "menstruation",
              "enabled": false
            }
          ]
        },
        {
          "title": "Toileting",
          "name": "toileting",
          "enabled": false,
          "actions": [
            {
              "title": "Toilet help",
              "name": "toiletHelp",
              "enabled": false
            },
            {
              "title": "Bed pan",
              "name": "bedPan",
              "enabled": false
            },
            {
              "title": "Urine bottle",
              "name": "urineBottle",
              "enabled": false
            },
            {
              "title": "Commode",
              "name": "commode",
              "enabled": false
            },
            {
              "title": "Pad check",
              "name": "padCheck",
              "enabled": false
            },
            {
              "title": "Pad checked",
              "name": "padChecked",
              "enabled": false
            },
            {
              "title": "Pad was checked",
              "name": "padWasChecked",
              "enabled": false
            },
            {
              "title": "Urinate",
              "name": "urinate",
              "enabled": false
            },
            {
              "title": "Bowels opened",
              "name": "bowelsOpened",
              "enabled": false
            },
            {
              "title": "Emptied",
              "name": "emptied",
              "enabled": false
            },
            {
              "title": "Help with toilet",
              "name": "helpWithToilet",
              "enabled": false
            },
            {
              "title": "Toileting-Other",
              "name": "toiletingOther",
              "enabled": false
            }
          ]
        },
        {
          "title": "Medical",
          "name": "medical",
          "enabled": false,
          "actions": [
            {
              "title": "Medication",
              "name": "medication",
              "enabled": false
            },
            {
              "title": "PRN Medication",
              "name": "prnMedication",
              "enabled": false
            },
            {
              "title": "Doctor",
              "name": "doctor",
              "enabled": false
            },
            {
              "title": "Nurse",
              "name": "nurse",
              "enabled": false
            },
            {
              "title": "Specialist",
              "name": "specialist",
              "enabled": false
            },
            {
              "title": "Professional",
              "name": "professional",
              "enabled": false
            },
            {
              "title": "Massage",
              "name": "massage",
              "enabled": false
            },
            {
              "title": "Wound",
              "name": "wound",
              "enabled": false
            },
            {
              "title": "Heat pack",
              "name": "heatPack",
              "enabled": false
            },
            {
              "title": "Cream",
              "name": "cream",
              "enabled": false
            },
            {
              "title": "Foot splint",
              "name": "footSplint",
              "enabled": false
            },
            {
              "title": "Hand splint",
              "name": "handSplint",
              "enabled": false
            },
            {
              "title": "Compression",
              "name": "compression",
              "enabled": false
            },
            {
              "title": "Skin integrity",
              "name": "skinIntegrity",
              "enabled": false
            },
            {
              "title": "Neuro OBS",
              "name": "neuroObs",
              "enabled": false
            },
            {
              "title": "Pulse",
              "name": "pulse",
              "enabled": false
            },
            {
              "title": "Blood test",
              "name": "bloodTest",
              "enabled": false
            },
            {
              "title": "Blood sugar",
              "name": "bloodSugar",
              "enabled": false
            },
            {
              "title": "Soft signs",
              "name": "softSigns",
              "enabled": false
            },
            {
              "title": "Insulin",
              "name": "insulin",
              "enabled": false
            },
            {
              "title": "Temperature",
              "name": "temperature",
              "enabled": false
            },
            {
              "title": "Blood pressure",
              "name": "bloodPressure",
              "enabled": false
            },
            {
              "title": "Blood O2",
              "name": "bloodO2",
              "enabled": false
            },
            {
              "title": "Blood INR",
              "name": "bloodINR",
              "enabled": false
            },
            {
              "title": "Respiration",
              "name": "respiration",
              "enabled": false
            },
            {
              "title": "Coronavirus",
              "name": "coronavirus",
              "enabled": false
            },
            {
              "title": "Consciousness",
              "name": "consciousness",
              "enabled": false
            },
            {
              "title": "NEWS2",
              "name": "news2",
              "enabled": false
            },
            {
              "title": "In pain",
              "name": "inPain",
              "enabled": false
            },
            {
              "title": "PAP therapy",
              "name": "papTherapy",
              "enabled": false
            },
            {
              "title": "Oxygen level",
              "name": "oxygenLevel",
              "enabled": false
            },
            {
              "title": "SD Check",
              "name": "sdCheck",
              "enabled": false
            },
            {
              "title": "SD Setup/Change",
              "name": "sdSetupChange",
              "enabled": false
            },
            {
              "title": "New catheter",
              "name": "newCatheter",
              "enabled": false
            },
            {
              "title": "Washout",
              "name": "washout",
              "enabled": false
            },
            {
              "title": "Add Bag",
              "name": "addBag",
              "enabled": false
            },
            {
              "title": "Cleaned",
              "name": "cleaned",
              "enabled": false
            },
            {
              "title": "PEG",
              "name": "peg",
              "enabled": false
            },
            {
              "title": "Stoma",
              "name": "stoma",
              "enabled": false
            },
            {
              "title": "Suction",
              "name": "suction",
              "enabled": false
            },
            {
              "title": "Tracheostomy",
              "name": "tracheostomy",
              "enabled": false
            },
            {
              "title": "Enema",
              "name": "enema",
              "enabled": false
            },
            {
              "title": "IV line flush",
              "name": "ivLineFlush",
              "enabled": false
            },
            {
              "title": "Sample",
              "name": "sample",
              "enabled": false
            },
            {
              "title": "Multistix",
              "name": "multistix",
              "enabled": false
            },
            {
              "title": "Ear syringe",
              "name": "earSyringe",
              "enabled": false
            },
            {
              "title": "Clinic",
              "name": "clinic",
              "enabled": false
            },
            {
              "title": "Hospital",
              "name": "hospital",
              "enabled": false
            },
            {
              "title": "Coronavirus symptom check",
              "name": "coronavirusSymptomCheck",
              "enabled": false
            },
            {
              "title": "Medical-Other",
              "name": "medicalOther",
              "enabled": false
            }
          ]
        }
      ]
    }
  ],
  "dailyCare": [
    {
      "title": "Personal Care",
      "name": "personalCare",
      "enabled": true,
      "actions": [
        {
          "title": "Catheter care",
          "name": "catheterCare",
          "enabled": false
        },
        {
          "title": "Menstruation",
          "name": "menstruation",
          "enabled": false
        }
      ]
    },
    {
      "title": "Toileting",
      "name": "toileting",
      "enabled": false,
      "actions": [
        {
          "title": "Toilet help",
          "name": "toiletHelp",
          "enabled": false
        },
        {
          "title": "Bed pan",
          "name": "bedPan",
          "enabled": false
        },
        {
          "title": "Urine bottle",
          "name": "urineBottle",
          "enabled": false
        },
        {
          "title": "Commode",
          "name": "commode",
          "enabled": false
        },
        {
          "title": "Pad check",
          "name": "padCheck",
          "enabled": false
        },
        {
          "title": "Pad checked",
          "name": "padChecked",
          "enabled": false
        },
        {
          "title": "Pad was checked",
          "name": "padWasChecked",
          "enabled": false
        },
        {
          "title": "Urinate",
          "name": "urinate",
          "enabled": false
        },
        {
          "title": "Bowels opened",
          "name": "bowelsOpened",
          "enabled": false
        },
        {
          "title": "Loose bowels",
          "name": "looseBowls",
          "enabled": false
        },
        {
          "title": "Emptied",
          "name": "emptied",
          "enabled": false
        },
        {
          "title": "Wet clothes",
          "name": "wetClothes",
          "enabled": false
        },
        {
          "title": "Soiled clothes",
          "name": "soiledClothes",
          "enabled": false
        },
        {
          "title": "Toileting-Other",
          "name": "toiletingOther",
          "enabled": false
        }
      ]
    },
    {
      "title": "Medical",
      "name": "medical",
      "enabled": false,
      "actions": [
        {
          "title": "Medication",
          "name": "medication",
          "enabled": false
        },
        {
          "title": "PRN Medication",
          "name": "PRNMedication",
          "enabled": false
        },
        {
          "title": "Doctor",
          "name": "doctor",
          "enabled": false
        },
        {
          "title": "Nurse",
          "name": "nurse",
          "enabled": false
        },
        {
          "title": "Specialist",
          "name": "specialist",
          "enabled": false
        },
        {
          "title": "Professional",
          "name": "professional",
          "enabled": false
        },
        {
          "title": "In pain",
          "name": "inPain",
          "enabled": false
        },
        {
          "title": "Massage",
          "name": "massage",
          "enabled": false
        },
        {
          "title": "Sick",
          "name": "sick",
          "enabled": false
        },
        {
          "title": "Call doctor",
          "name": "callDoctor",
          "enabled": false
        },
        {
          "title": "Ambulance",
          "name": "ambulance",
          "enabled": false
        },
        {
          "title": "Wound",
          "name": "wound",
          "enabled": false
        },
        {
          "title": "Heat pack",
          "name": "heatPack",
          "enabled": false
        },
        {
          "title": "Cream",
          "name": "cream",
          "enabled": false
        },
        {
          "title": "Foot splint",
          "name": "footSplint",
          "enabled": false
        },
        {
          "title": "Hand splint",
          "name": "handSplint",
          "enabled": false
        },
        {
          "title": "Compression",
          "name": "compression",
          "enabled": false
        },
        {
          "title": "Skin integrity",
          "name": "skinIntegrity",
          "enabled": false
        },
        {
          "title": "Neuro Obs",
          "name": "neuroObs",
          "enabled": false
        },
        {
          "title": "Pulse",
          "name": "pulse",
          "enabled": false
        },
        {
          "title": "Blood test",
          "name": "bloodTest",
          "enabled": false
        },
        {
          "title": "Blood sugar",
          "name": "bloodSugar",
          "enabled": false
        },
        {
          "title": "Soft signs",
          "name": "softSigns",
          "enabled": false
        },
        {
          "title": "Insulin",
          "name": "insulin",
          "enabled": false
        },
        {
          "title": "Temperature",
          "name": "temperature",
          "enabled": false
        },
        {
          "title": "Blood pressure",
          "name": "bloodPressure",
          "enabled": false
        },
        {
          "title": "Blood O2",
          "name": "bloodO2",
          "enabled": false
        },
        {
          "title": "Blood INR",
          "name": "bloodINR",
          "enabled": false
        },
        {
          "title": "Respiration",
          "name": "respiration",
          "enabled": false
        },
        {
          "title": "Coronavirus",
          "name": "coronavirus",
          "enabled": false
        },
        {
          "title": "Choking Intervention",
          "name": "chokingIntervention",
          "enabled": false
        },
        {
          "title": "Consciousness",
          "name": "consciousness",
          "enabled": false
        },
        {
          "title": "NEWS2",
          "name": "NEWS2",
          "enabled": false
        },
        {
          "title": "PAP therapy",
          "name": "PAPTherapy",
          "enabled": false
        },
        {
          "title": "Oxygen level",
          "name": "oxygenLevel",
          "enabled": false
        },
        {
          "title": "SD Check",
          "name": "SDCheck",
          "enabled": false
        },
        {
          "title": "SD Setup / Change",
          "name": "SDSetupChange",
          "enabled": false
        },
        {
          "title": "New catheter",
          "name": "newCatheter",
          "enabled": false
        },
        {
          "title": "Washout",
          "name": "washout",
          "enabled": false
        },
        {
          "title": "Add bag",
          "name": "addBag",
          "enabled": false
        },
        {
          "title": "Cleaned",
          "name": "cleaned",
          "enabled": false
        },
        {
          "title": "PEG",
          "name": "PEG",
          "enabled": false
        },
        {
          "title": "Epileptic seizure",
          "name": "epilepticSeizure",
          "enabled": false
        },
        {
          "title": "Stoma",
          "name": "stoma",
          "enabled": false
        },
        {
          "title": "Suction",
          "name": "suction",
          "enabled": false
        },
        {
          "title": "Tracheostomy",
          "name": "tracheostomy",
          "enabled": false
        },
        {
          "title": "Enema",
          "name": "enema",
          "enabled": false
        },
        {
          "title": "IV line flush",
          "name": "IVLineFlush",
          "enabled": false
        },
        {
          "title": "Sample",
          "name": "sample",
          "enabled": false
        },
        {
          "title": "Multistix",
          "name": "multistix",
          "enabled": false
        },
        {
          "title": "Ear syringe",
          "name": "earSyringe",
          "enabled": false
        },
        {
          "title": "Clinic",
          "name": "clinic",
          "enabled": false
        },
        {
          "title": "Hospital",
          "name": "hospital",
          "enabled": false
        },
        {
          "title": "Medical-Other",
          "name": "medicalOther",
          "enabled": false
        }
      ]
    }
  ]
};
